import { ApiProperty } from "@nestjs/swagger";

export class columnByIdDto{
    @ApiProperty()
    columnsId:number;
}